import i18n from '../i18n';

export const getApiMessage = (response, fallback = 'An error occurred') => {
    if (!response) return fallback;

    // Get current language from i18n
    const currentLang = i18n.language || 'en';

    // Check if language-specific message exists
    if (currentLang === 'es' && response.message_es) {
        return response.message_es;
    }

    if (currentLang === 'en' && response.message_en) {
        return response.message_en;
    }

    // Fallback to generic message if language-specific not available
    if (response.message) {
        return response.message;
    }

    return fallback;
};


export const showToast = (toastFn, response, fallback) => {
    const message = getApiMessage(response, fallback);
    toastFn(message);
};
